export type APIUserType = Partial<{
  id: number;
  email: string;
  name: string;
  super_admin_role: "owner";
}>;
export interface IUser {
  getId(): number | undefined;
  getEmail(): string | undefined;
  getName(): string | undefined;
  isSuperAdmin(): boolean;
  getUser(): APIUserType;
}

export class User implements IUser {
  readonly data: APIUserType;
  constructor(data: APIUserType) {
    this.data = data;
  }
  getUser(): APIUserType {
    return this.data;
  }
  getId(): number | undefined {
    return this.data.id;
  }
  getEmail(): string | undefined {
    return this.data.email;
  }
  getName(): string | undefined {
    return this.data.name;
  }
  isSuperAdmin(): boolean {
    return this.data.super_admin_role === "owner";
  }
}
